define([
    'backbone',
    'mixins/models/labeledentity'
], (Backbone, Model) => Model.extend({
    optionsModel: null,

    initialize () {
        if (this.optionsModel) {
            this.nested = {options: this.optionsModel};
        }

        Model.prototype.initialize.apply(this, arguments);
    },

    urlRoot () {
        return `${Model.prototype.prefix.apply(this)}/bidmanager/groups`;
    },

    defaults () {
        return {
            placement_ids: [],
            labels: [],
            enabled: true,
            channel_id: null,
            is_logging_enabled: false,
            day_of_week: _.range(7),
            time_of_day: _.range(24)
        };
    }

}));
